import { z } from 'zod';

import { schemaEuropaceBenachrichtigung } from './Benachrichtigung.schema';
import { schemaEuropaceVorgang_Export } from './Vorgang_Export.schema';

/*
    https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#vorgang

    {
        "kundenbetreuer": Partner,
        "bearbeiter": Partner,
        "tippgeber": Partner,
        "leadquelle": String,
        "benachrichtigung": Benachrichtigung,
        "eigeneVorgangsnummer": String,
        "baufiSmartVorgangsnummer": String,
        "antragsteller1": Antragsteller,
        "antragsteller2": Antragsteller,
        "haushalt": Haushalt,
        "finanzbedarf": Finanzbedarf,
        "kommentare": [ String ]
    }
*/

export const schemaEuropaceVorgang = schemaEuropaceVorgang_Export
    .pick({
        antragsteller1: true,
        antragsteller2: true,
        bearbeiter: true,
        eigeneVorgangsnummer: true,
        finanzbedarf: true,
        haushalt: true,
        kundenbetreuer: true,
        leadquelle: true,
        tippgeber: true,
    })
    .merge(
        z.object({
            // we need to set this to nullish, so the antragsteller2 can be null if this value should be hidden
            antragsteller2: schemaEuropaceVorgang_Export.shape.antragsteller2.unwrap().nullish(),
            // not sure what this is exactly
            baufiSmartVorgangsnummer: z.optional(z.string()),
            benachrichtigung: z.optional(schemaEuropaceBenachrichtigung),
            kommentare: z.optional(z.array(z.string())),
        }),
    )
    .strip();
export type SchemaEuropaceVorgang = z.infer<typeof schemaEuropaceVorgang>;
